import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';

const baseTranslateUrl = './assets/i18n/tracker/myhp';
const moduleName = 'tracker-myhp';
export const trackerMyHP: Array<IModuleTranslation> = [
  {
    baseTranslateUrl,
    moduleName,
    pathTemplate: '{baseTranslateUrl}/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-disconnect`,
    pathTemplate: '{baseTranslateUrl}/disconnect/{language}'
  }
];
